module.exports = __webpack_public_path__ + "img/pie.069b6b5a.svg";